import ACL from "@/features/ACL/ACL";
import { Route, Routes } from "react-router-dom";
import AddRoleScratch from "@/features/ACL/addRole/AddRoleScratch";

const AclPage = () => {
  return (
    <Routes>
      <Route path="/" element={<ACL />} />
      <Route path="/add" element={<AddRoleScratch />} />
    </Routes>
  );
};

export default AclPage;
